import { createSelector } from 'reselect';

import { selectRadioActive } from '@pressreader/article';
import { selectGetConfigValue } from '@pressreader/config';
import { selectRadioEnabled } from '@pressreader/global-config';
import { ToCamelCase, toCamelCase } from '@pressreader/utils';

import ndUser from 'nd.user';

import { IExternalAuthenticationDto, ISiteNavConfig } from '../types';

export const selectLegacyExternalAuthConfig = createSelector(selectGetConfigValue, (getConfigValue): ToCamelCase<IExternalAuthenticationDto> => {
    const dto = getConfigValue<IExternalAuthenticationDto>('Authentication');
    return toCamelCase(dto);
});

export const selectEmailAlertsEnabled = createSelector(selectGetConfigValue, getConfigValue =>
    getConfigValue<boolean>('ui.Sidebar.ShowEmailAlerts', true),
);

export const selectSearchEnabled = createSelector(selectGetConfigValue, getConfigValue =>
    getConfigValue<boolean>('ui.TopToolbar.SearchEnabled', true),
);

export const selectAppHeaderEnabled = createSelector(selectGetConfigValue, getConfigValue =>
    getConfigValue<boolean>('features.app.header.enabled', false),
);

export const selectSignoutLocation = createSelector(selectLegacyExternalAuthConfig, externalAuthConfig =>
    externalAuthConfig.enablePublisherAuthenticationWebService && externalAuthConfig.externalLogoutPage
        ? externalAuthConfig.externalLogoutPage
        : ndUser.getRedirectionUrl('AfterSignOut'),
);

export const selectSiteNavConfig = createSelector(
    selectGetConfigValue,
    selectLegacyExternalAuthConfig,
    selectRadioEnabled,
    selectRadioActive,
    (getConfigValue, externalAuthConfig, radioEnabled, getRadioActive): ISiteNavConfig => {
        const radioActive = getRadioActive();
        return {
            myAccount: {
                enabled: getConfigValue<boolean>('pagesView.enableMyAccountMenu', true),
                location: externalAuthConfig.externalMyAccountPage,
            },
            myTopics: {
                enabled: getConfigValue<boolean>('ui.Sidebar.MonitorsEnabled', false) && getConfigValue<boolean>('ui.MyTopics.enable', true),
            },
            catalog: {
                enabled: getConfigValue<boolean>('ui.Sidebar.CatalogEnabled', true),
            },
            bookmarks: {
                enabled: getConfigValue<boolean>('ui.Bookmarks.enable', true),
            },
            radio: { radioEnabled, radioActive },
            print: {
                enabled: getConfigValue<boolean>('ui.Print.enable', true),
            },
            translate: {
                enabled: getConfigValue<boolean>('ui.Translate.enable', true),
            },
            blog: {
                enabled: getConfigValue<boolean>('ui.Sidebar.BlogEnabled', false),
                location: getConfigValue<string>('ui.Sidebar.BlogLocation', ''),
            },
            customItem: {
                enabled: getConfigValue<boolean>('pagesView.ShowCustomItem', false),
                location: getConfigValue<string>('pagesView.CustomItemURL', ''),
            },
        };
    },
);
